import { DEFAULTS } from "./defaults.js";
import { COLLAPSIBLE_LIST_TYPE } from "./types.js";
import { nodeViewRenderers } from "./viewer/node-view-renderers.js";
const pluginCollapsibleList = (config) => {
  return {
    config: { ...DEFAULTS.config, ...config },
    type: COLLAPSIBLE_LIST_TYPE,
    nodeViewRenderers
  };
};
export {
  pluginCollapsibleList
};
//# sourceMappingURL=viewer.js.map
